import { forwardRef } from "react";
import { techStackDetails } from "../Details";
const { html, css, js, react, nextjs, redux, chakraUi, tailwind, nodeJs, express, mongodb, mongoose, awsS3, awsTextract, gcp, postman, npm, git, github, sass } = techStackDetails;

export const Technologies = forwardRef((_, ref) => {
  return (
    <main ref={ref} id="technologies" className="container mx-auto max-width pt-[6vw] pb-20 ">
      <section className="text-center">
        <h1 className="text-2xl text-center text-dark-heading dark:text-light-heading md:text-4xl xl:text-4xl xl:leading-tight font-bold">
          Tech Stack
        </h1>
        <p className="text-content text-center py-2">Technologies I've been working with recently</p>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={html[0]} width={90} height={100} title={html[1]} alt="" />
        <img src={css[0]} width={90} height={100} title={css[1]} alt="" />
        <img src={js[0]} width={90} height={100} title={js[1]} alt="" />
        <img src={react[0]} width={90} height={100} title={react[1]} alt="" />
        <img src={nextjs[0]} width={90} height={100} title={nextjs[1]} alt="" />
        <img src={redux[0]} width={90} height={100} title={redux[1]} alt="" />
        <img src={chakraUi[0]} width={90} height={100} title={chakraUi[1]} alt="" />
        <img src={tailwind[0]} width={90} height={100} title={tailwind[1]} alt="" />
        <img src={nodeJs[0]} width={90} height={100} title={nodeJs[1]} alt="" />
        <img src={express[0]} width={90} height={100} title={express[1]} alt="" />
        <img src={mongodb[0]} width={90} height={100} title={mongodb[1]} alt="" />
        <img src={mongoose[0]} width={90} height={100} title={mongoose[1]} alt="" />
        <img src={awsS3[0]} width={90} height={100} title={awsS3[1]} alt="" />
        <img src={awsTextract[0]} width={90} height={100} title={awsTextract[1]} alt="" />
        <img src={gcp[0]} width={90} height={100} title={gcp[1]} alt="" />
        <img src={sass[0]} width={90} height={100} title={sass[1]} alt="" />
      </section>
      <section>
        <h1 className="text-2xl text-center pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-4xl xl:leading-tight font-bold">
          Tools
        </h1>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={git[0]} width={90} height={100} title={git[1]} alt="Git" />
        <img src={github[0]} width={90} height={100} title={github[1]} alt="Github" />
        <img src={npm[0]} width={90} height={100} title={npm[1]} alt="NPM" />
        <img src={postman[0]} width={90} height={100} title={postman[1]} alt="Postman" />
      </section>
    </main>
  );
});
